import React from 'react';

/**
 * PageHeader — editorial header for interior pages.
 * eyebrow → display heading (with optional italicized accent) → lede →
 * optional actions cluster on the right.
 *
 * Use the `accent` prop to italicize the second line of the title in clay,
 * or split the title manually via the `titleAccent` slot.
 */
export const PageHeader = ({
  eyebrow,
  title,
  titleAccent,
  lede,
  actions,
  align = 'left',
  size = 'lg',
  className = '',
}) => {
  const sizeMap = {
    md: 'text-display-md',
    lg: 'text-display-lg',
    xl: 'text-display-xl',
  };
  const alignMap =
    align === 'center'
      ? 'text-center mx-auto items-center'
      : 'text-left items-start';

  return (
    <header className={`flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 ${className}`}>
      <div className={`flex flex-col ${alignMap} max-w-3xl`}>
        {eyebrow && <div className="eyebrow mb-3">{eyebrow}</div>}
        <h1 className={`font-display ${sizeMap[size]} text-ink leading-[1.05]`}>
          {title}
          {titleAccent && (
            <>
              <br />
              <span
                className="italic text-clay-700"
                style={{ fontVariationSettings: '"opsz" 144, "SOFT" 80' }}
              >
                {titleAccent}
              </span>
            </>
          )}
        </h1>
        {lede && (
          <p className="mt-4 text-lg text-ink-soft leading-relaxed max-w-2xl">{lede}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
    </header>
  );
};

export default PageHeader;
